import { render, staticRenderFns } from "./DwSummary.vue?vue&type=template&id=fb55ee9c&scoped=true&"
import script from "./DwSummary.vue?vue&type=script&lang=js&"
export * from "./DwSummary.vue?vue&type=script&lang=js&"
import style0 from "./DwSummary.vue?vue&type=style&index=0&id=fb55ee9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb55ee9c",
  null
  
)

export default component.exports